export default __webpack_public_path__ + "static/media/objects-life-preserver.16e85e46.svg";